import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  ContentStoreService,
  MxLoggerService,
  AuthStoreService,
  NavMenu,
  UserSettings,
} from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { SiteSettings } from '../../../model/core/site-settings';
import { User } from '../../../model/user';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @ViewChild('header', { static: true }) headerElement: ElementRef<HTMLElement>;

  logoUrl = 'https://mmicdn.s3.eu-central-1.amazonaws.com/Lenovo+Boost/Images/Refresh/lenovo-boost-360.svg';
  headerFixed = environment.headerFixed;

  authenticatedUser$ = this.authStore.authenticatedUser$.pipe(untilDestroyed(this));

  headerMenu: NavMenu;

  totalSales: number;
  totalRebate: number;
  quarter: string;
  currencySymbol: string;
  regionCode: string;
  countryCode: string;
  excludedLocales: string[] = [];

  disableInAustralia$ = this.contentStore.siteSettings$.pipe(
    filter(Boolean),
    map((siteSettings) => (siteSettings as unknown as SiteSettings).siteSettings?.disableInAustralia === true),
    switchMap((disableInAustralia) =>
      this.authStore.userSettings$.pipe(
        (filter(Boolean), map((userSettings: any) => userSettings?.country.alpha2Code === 'AU' && disableInAustralia))
      )
    )
  );

  constructor(
    private authStore: AuthStoreService,
    private renderer: Renderer2,
    private contentStore: ContentStoreService,
    private mxLogger: MxLoggerService
  ) {}

  ngOnInit(): void {
    this.contentStore.headerMenu$.pipe(filter(Boolean)).subscribe((headerMenu) => {
      this.mxLogger.debug('HeaderComponent', 'ngOnInit() headerMenu=', headerMenu);

      this.headerMenu = headerMenu;
    });

    this.authStore.userSettings$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((userSettings) => {
      if (userSettings.user != null) {
        this.regionCode = (userSettings as UserSettings<User>).user.region.regionCode;
      }

      this.countryCode = userSettings.country?.alpha2Code;
      this.excludedLocales = this.countryCode === 'CA' ? ['fr-FR'] : [];
    });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    if (environment.headerFixed) {
      if (window.scrollY > 0) {
        this.renderer.addClass(this.headerElement.nativeElement, 'scrolled');
      } else {
        this.renderer.removeClass(this.headerElement.nativeElement, 'scrolled');
      }
    }
  }
}
